import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MainLayout = ({ user, onLogoutClick, onSignInClick }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isHome = location.pathname === "/";
  const isQrTrip = location.pathname.startsWith("/qr-trip/");

  const showHeader = !isQrTrip;
  const showFooter = isHome;

  /* ⭐ LOGIN QUERY DETECTOR */
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get("login") === "true") {
      onSignInClick();
    }
  }, [location, onSignInClick]);

  useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, [location.pathname]);

  return (
    <>
      {showHeader && (
        <>
          <Header
            user={user}
            variant={isHome ? "home" : "compact"}
            onHomeClick={() => navigate("/")}
            onItinerariesClick={() => navigate("/itineraries")}
            onSavedClick={() => navigate("/saved")}
            onBlogsClick={() => navigate("/blogs")}
            onCitClick={() => navigate("/cities")}
            onLogoutClick={onLogoutClick}
            onSignInClick={onSignInClick}
          />

          <div className={isHome ? "h-[24px]" : "h-[66px]"} />
        </>
      )}

      <main className="min-h-screen">
        <Outlet />
      </main>

      {showFooter && <Footer />}
    </>
  );
};

export default MainLayout;